export default "__VITE_ASSET__DfUXsQcj__"